import { EVENT_NAME, PRODUCT } from './constants';
import TemplateData, { localsMessages } from './getTemplateData';
import AppStore from '../stores/AppStore';
import { formatCurrencyWithSymbol, normalizeNumber } from './formator';
import { getPersonalizedMessages } from './personalizedMessages';
import { GN_CONTENT_TOUCHPOINT } from './constants';
import { isInContext } from './inContextDonation';

const gncMessages = localsMessages('clients/generosityNetworkCharities');

export const isGNC = () =>
  TemplateData.product === PRODUCT.GENEROSITY_NETWORK_CHARITIES;
export const isGN = () => TemplateData.product === PRODUCT.GENEROSITY_NETWORK;
export const isBrandedCampaign = () =>
  TemplateData.product === PRODUCT.BRANDED_CAMPAIGN;
export const isPPFundraising = () =>
  TemplateData.product === PRODUCT.PP_FUNDRAISING;

export const isCheckoutRail = () => isGNC() || isPPFundraising();
export const isSendMoneyRail = () => isGN() || isBrandedCampaign();

export const isExternalFlow = () =>
  isGNC() || isGN() || isBrandedCampaign() || isPPFundraising();

export const prepareOrderParams = () => ({
  amount: normalizeNumber(AppStore.getDonationAmount()),
  addressSharingConsent: false,
  currencyCode: AppStore.getDonationCode(),
  currencySymbol: AppStore.getDonationSymbol(),
  donationAmountType:
    AppStore.getDonationAmountType() === 'preset' ? 'preset' : 'userinput',
  donationNote: AppStore.getDonationNote() || '',
  recurring: AppStore.getDonationRecurring(),
  selectedProgram: AppStore.getSelectedProgram(),
  selectedPresetButtonId: AppStore.getSelectedPresetButtonId(),
  token: TemplateData.token,
  anonymousStatus: AppStore.getAnonymousStatus(),
  ppgfMessage: gncMessages?.ppgfMessage,
  directMessage: gncMessages?.directMessage,
  isInContext: isInContext(),
});

export const getMaximumDonationAlertMessage = () => {
  const formatedMaximumAmount = formatCurrencyWithSymbol({
    value: TemplateData.maximumDonationAmount,
    currency: TemplateData.maximumDonationCurrency,
  });
  const alertMessage = gncMessages.maximumAmountAlert.replace(
    '{amount}',
    formatedMaximumAmount
  );

  return alertMessage;
};

export const getPersonalizedNoteToPayeeLabel = () => {
  const psMessages = getPersonalizedMessages(GN_CONTENT_TOUCHPOINT, {
    isHtml: false,
  });
  return psMessages?.noteToPayeeLabel;
};

export const getPersonalizedAnonymousContent = () => {
  const psMessages = getPersonalizedMessages(GN_CONTENT_TOUCHPOINT, {
    isHtml: false,
  });
  return {
    label: psMessages?.anonymousLabel,
    tooltip: psMessages?.anonymousTooltip,
  };
};

export const getDismissEventName = () => {
  const url = window.location.href;

  if (url.includes('confirmation') || url.includes('pending')) {
    return EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_DISMISS_PRESSED;
  } else if (url.includes('guest')) {
    return EVENT_NAME.DW_GIVING_GUEST_FORM_DISMISS_PRESSED;
  } else if (url.includes('member')) {
    return EVENT_NAME.DW_GIVING_MEMBER_REVIEW_DISMISS_PRESSED;
  }
  return EVENT_NAME.DW_GIVING_DONATE_SETUP_DISMISS_PRESSED;
};
